import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = {
  class: "form-group control-with-icon mb-0",
  id: "projectStatus"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<option class=\"to-upper\" value=\"\">All</option><option class=\"to-upper\" value=\"0\">Draft</option><option class=\"to-upper\" value=\"1\">Sent</option><option class=\"to-upper\" value=\"2\">Approved</option><option class=\"to-upper\" value=\"3\">Declined</option><option class=\"to-upper\" value=\"4\">Smart Contract Created</option>", 6)
const _hoisted_14 = { class: "col-md-6 text-md-right" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_18 = { class: "table table-borderless mb-0" }
const _hoisted_19 = { class: "table-primary nowrap-text" }
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { scope: "col" }
const _hoisted_22 = { scope: "col" }
const _hoisted_23 = { scope: "col" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_26 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_27 = {
  key: 2,
  class: "badge badge-success"
}
const _hoisted_28 = {
  key: 3,
  class: "badge badge-danger"
}
const _hoisted_29 = {
  key: 4,
  class: "badge badge-info"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "text-nowrap" }
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "fa fa-paper-plane" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { colspan: "5" }
const _hoisted_42 = { class: "modal-wrap default-modal" }
const _hoisted_43 = {
  class: "modal fade",
  id: "deleteJobEstimation",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_49 = { class: "modal-body" }
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_51 = { class: "text-danger" }
const _hoisted_52 = { class: "modal-footer" }
const _hoisted_53 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_54 = {
  class: "modal fade",
  id: "showDetailsAdmin",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_55 = { class: "modal-dialog" }
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-header" }
const _hoisted_58 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Print")
const _hoisted_60 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close",
  click: "detailsClose",
  title: "close"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_62 = { class: "modal-body bg-light" }
const _hoisted_63 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_64 = { class: "d-flex" }
const _hoisted_65 = { class: "flex-grow-1" }
const _hoisted_66 = { class: "invoice-logo" }
const _hoisted_67 = { class: "invoice-address" }
const _hoisted_68 = { class: "uppercase-text" }
const _hoisted_69 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_70 = { class: "text-muted" }
const _hoisted_71 = { class: "text-muted" }
const _hoisted_72 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-md-3" }
const _hoisted_75 = { class: "text-muted uppercase-text" }
const _hoisted_76 = { class: "col-md-3" }
const _hoisted_77 = { class: "text-muted uppercase-text" }
const _hoisted_78 = { class: "col-md-3" }
const _hoisted_79 = { class: "text-muted uppercase-text" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { class: "mt-4" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "mt-3 border p-2" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "to-upper" }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { key: 2 }
const _hoisted_90 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_91 = { class: "table table-borderless mb-0" }
const _hoisted_92 = { class: "table-primary nowrap-text" }
const _hoisted_93 = { class: "table-active" }
const _hoisted_94 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_95 = { scope: "col" }
const _hoisted_96 = { scope: "col" }
const _hoisted_97 = { scope: "col" }
const _hoisted_98 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_99 = { scope: "col" }
const _hoisted_100 = { scope: "col" }
const _hoisted_101 = { scope: "col" }
const _hoisted_102 = {
  scope: "col",
  class: "text-end to-upper"
}
const _hoisted_103 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_104 = { class: "mb-0" }
const _hoisted_105 = { class: "ps-3" }
const _hoisted_106 = { class: "desc-wrap" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { class: "text-end" }
const _hoisted_110 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_111 = { class: "row justify-content-end" }
const _hoisted_112 = { class: "col-lg-3 col-md-9" }
const _hoisted_113 = { class: "total-box" }
const _hoisted_114 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_115 = { scope: "row" }
const _hoisted_116 = { class: "text-end" }
const _hoisted_117 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_118 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_119 = { class: "mb-0" }
const _hoisted_120 = { class: "uppercase-text" }
const _hoisted_121 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_122 = {
  key: 0,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_123 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_124 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_125 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_126 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_127 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_128 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_129 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_130 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_131 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_132 = {
  key: 1,
  class: "alert alert-info mt-3"
}
const _hoisted_133 = { class: "mb-0" }
const _hoisted_134 = {
  key: 2,
  class: "mt-3 pl-3"
}
const _hoisted_135 = { class: "mb-0" }
const _hoisted_136 = /*#__PURE__*/_createVNode("strong", null, " Channel: ", -1)
const _hoisted_137 = {
  key: 3,
  class: "card d-block mt-3"
}
const _hoisted_138 = { class: "card-head pb-3" }
const _hoisted_139 = { class: "card-title" }
const _hoisted_140 = { class: "row" }
const _hoisted_141 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_142 = { class: "signature-wrap my-2" }
const _hoisted_143 = { class: "signature-wrap my-2" }
const _hoisted_144 = { class: "to-upper" }
const _hoisted_145 = { class: "modal-footer" }
const _hoisted_146 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_147 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_148 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_149 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_150 = {
  class: "modal fade",
  id: "showDetails",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_151 = { class: "modal-dialog" }
const _hoisted_152 = { class: "modal-content" }
const _hoisted_153 = { class: "modal-header" }
const _hoisted_154 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_155 = /*#__PURE__*/_createTextVNode(" Print")
const _hoisted_156 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_157 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "close",
  "data-dismiss": "modal",
  "aria-label": "Close",
  click: "detailsClose"
}, [
  /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
], -1)
const _hoisted_158 = { class: "modal-body bg-light" }
const _hoisted_159 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_160 = { class: "d-flex" }
const _hoisted_161 = { class: "flex-grow-1" }
const _hoisted_162 = { class: "invoice-logo" }
const _hoisted_163 = { class: "invoice-address" }
const _hoisted_164 = { class: "uppercase-text" }
const _hoisted_165 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_166 = { class: "text-muted" }
const _hoisted_167 = { class: "text-muted" }
const _hoisted_168 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_169 = { class: "row" }
const _hoisted_170 = { class: "col-md-3" }
const _hoisted_171 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_172 = { class: "col-md-3" }
const _hoisted_173 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_174 = { class: "col-md-3" }
const _hoisted_175 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_176 = { key: 0 }
const _hoisted_177 = { key: 1 }
const _hoisted_178 = { class: "mt-4" }
const _hoisted_179 = { key: 0 }
const _hoisted_180 = { class: "row" }
const _hoisted_181 = { class: "mt-3 border p-2" }
const _hoisted_182 = { key: 0 }
const _hoisted_183 = { key: 1 }
const _hoisted_184 = { key: 2 }
const _hoisted_185 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_186 = {
  key: 0,
  class: "table table-borderless mb-0"
}
const _hoisted_187 = { class: "table-primary nowrap-text" }
const _hoisted_188 = { class: "table-active" }
const _hoisted_189 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_190 = { scope: "col" }
const _hoisted_191 = { scope: "col" }
const _hoisted_192 = { scope: "col" }
const _hoisted_193 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_194 = { scope: "col" }
const _hoisted_195 = { scope: "col" }
const _hoisted_196 = {
  scope: "col",
  class: "text-end to-upper"
}
const _hoisted_197 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_198 = { class: "mb-0" }
const _hoisted_199 = { class: "ps-3" }
const _hoisted_200 = { class: "desc-wrap" }
const _hoisted_201 = { key: 0 }
const _hoisted_202 = { key: 1 }
const _hoisted_203 = { class: "text-end" }
const _hoisted_204 = {
  key: 1,
  class: "table mb-0 table-borderless"
}
const _hoisted_205 = { class: "table-primary nowrap-text" }
const _hoisted_206 = { class: "table-active" }
const _hoisted_207 = { scope: "col" }
const _hoisted_208 = {
  key: 0,
  scope: "col"
}
const _hoisted_209 = {
  key: 1,
  scope: "col"
}
const _hoisted_210 = {
  key: 2,
  scope: "col"
}
const _hoisted_211 = {
  key: 3,
  scope: "col"
}
const _hoisted_212 = {
  key: 4,
  scope: "col"
}
const _hoisted_213 = {
  key: 5,
  scope: "col"
}
const _hoisted_214 = {
  key: 6,
  scope: "col"
}
const _hoisted_215 = {
  key: 7,
  scope: "col",
  class: "to-upper"
}
const _hoisted_216 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_217 = { class: "mb-0" }
const _hoisted_218 = { class: "ps-3" }
const _hoisted_219 = { key: 0 }
const _hoisted_220 = { class: "desc-wrap" }
const _hoisted_221 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_222 = { key: 2 }
const _hoisted_223 = {
  key: 3,
  class: "text-nowrap"
}
const _hoisted_224 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_225 = {
  key: 5,
  class: "text-nowrap"
}
const _hoisted_226 = { key: 0 }
const _hoisted_227 = { key: 1 }
const _hoisted_228 = {
  key: 6,
  class: "text-nowrap"
}
const _hoisted_229 = {
  key: 7,
  class: "text-end"
}
const _hoisted_230 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_231 = { class: "row justify-content-end" }
const _hoisted_232 = { class: "col-lg-3 col-md-9" }
const _hoisted_233 = { class: "total-box" }
const _hoisted_234 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_235 = { scope: "row" }
const _hoisted_236 = { class: "text-end" }
const _hoisted_237 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_238 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_239 = { class: "mb-0" }
const _hoisted_240 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_241 = {
  key: 2,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_242 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_243 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_244 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_245 = { class: "alert alert-info mt-3" }
const _hoisted_246 = { class: "mb-0" }
const _hoisted_247 = { class: "mt-3 pl-3" }
const _hoisted_248 = { class: "mb-0" }
const _hoisted_249 = { class: "card d-block mt-3" }
const _hoisted_250 = { class: "card-head pb-3" }
const _hoisted_251 = { class: "card-title" }
const _hoisted_252 = { class: "row" }
const _hoisted_253 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_254 = { class: "signature-wrap my-2" }
const _hoisted_255 = { class: "signature-wrap my-2" }
const _hoisted_256 = { class: "to-upper" }
const _hoisted_257 = { class: "modal-footer" }
const _hoisted_258 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_259 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_260 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_UpgradeSubscriptionModal = _resolveComponent("UpgradeSubscriptionModal")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.geJobEstimationList && !_ctx.state.ui.isLoading.pusherUpdate)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.filterStatus = $event))
            }, [
              _hoisted_8
            ], 512), [
              [_vModelSelect, _ctx.state.filterStatus]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          (_ctx.hasRole(['owner', 'co-owner']) && !(_ctx.projectStatus ==2))
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                href: "javascript:void(0)",
                class: "btn default-btn d-inline-block",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoCreateJobEstimation && _ctx.gotoCreateJobEstimation(...args)))
              }, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('create')) + " " + _toDisplayString(_ctx.$t('job_estimation')), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _createVNode("table", _hoisted_18, [
          _createVNode("thead", _hoisted_19, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('estimation_no')), 1),
              _createVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('status')), 1),
              _createVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('date')), 1),
              _createVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('action')), 1)
            ])
          ]),
          (_ctx.state.data.jobEstimationLists.length > 0)
            ? (_openBlock(), _createBlock("tbody", _hoisted_24, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredEstimations, (estimation, estimationIndex) => {
                  return (_openBlock(), _createBlock("tr", { key: estimationIndex }, [
                    _createVNode("td", null, [
                      _createVNode("p", null, "# " + _toDisplayString(estimation.no) + " " + _toDisplayString(estimation.title), 1)
                    ]),
                    _createVNode("td", null, [
                      (estimation.status == 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('draft')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('sent')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('approved')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('declined')), 1))
                        : _createCommentVNode("", true),
                      (estimation.status == 4)
                        ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('smart_contract_created')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", null, [
                      (estimation.modifiedCreatedDate)
                        ? (_openBlock(), _createBlock("p", _hoisted_30, _toDisplayString(estimation.modifiedCreatedDate), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_31, _toDisplayString(estimation.created_date), 1))
                    ]),
                    _createVNode("td", _hoisted_32, [
                      ((estimation.status == 0 || estimation.status == 3) && _ctx.hasRole(['owner', 'co-owner']) && !(_ctx.projectStatus ==2))
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.gotoJobEstimationSend(estimation.uuid)),
                            title: "send"
                          }, [
                            _hoisted_33,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('send')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (estimation.status == 1 && _ctx.hasRole(['owner', 'co-owner']) && !(_ctx.projectStatus ==2))
                        ? (_openBlock(), _createBlock("a", {
                            key: 1,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.updateJobEstimation(estimation.uuid)),
                            title: "edit"
                          }, [
                            _hoisted_34,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ((estimation.status == 0 || estimation.status == 3) && _ctx.hasRole(['owner', 'co-owner']) && !(_ctx.projectStatus ==2))
                        ? (_openBlock(), _createBlock("a", {
                            key: 2,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.editJobEstimation(estimation.uuid)),
                            title: "edit"
                          }, [
                            _hoisted_35,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.hasRole(['owner', 'co-owner']))
                        ? (_openBlock(), _createBlock("a", {
                            key: 3,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.detailsShowAdmin(estimation)),
                            title: "admin preview"
                          }, [
                            _hoisted_36,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('admin_preview')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ((estimation.same == 0 && estimation.status != 0 && _ctx.hasRole(['owner', 'co-owner'])) ||
                                        (estimation.status != 0 && _ctx.hasRole(['todo_payer', 'estimation_member'])))
                        ? (_openBlock(), _createBlock("a", {
                            key: 4,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            onClick: ($event: any) => (_ctx.detailsShow(estimation)),
                            title: "customer preview"
                          }, [
                            _hoisted_37,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('customer_preview')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      ((estimation.status == 0 || estimation.status == 3) && _ctx.hasRole(['owner', 'co-owner']) && !(_ctx.projectStatus ==2))
                        ? (_openBlock(), _createBlock("a", {
                            key: 5,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-danger",
                            onClick: ($event: any) => (_ctx.deleteJobEstimationShow(estimationIndex, estimation)),
                            title: "delete"
                          }, [
                            _hoisted_38,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (estimation.status == 2 && _ctx.hasRole(['owner', 'co-owner']) && !(_ctx.projectStatus ==2))
                        ? (_openBlock(), _createBlock("a", {
                            key: 6,
                            href: "javascript:void(0)",
                            class: "btn btn-sm text-primary mr-1",
                            title: "create smart contract",
                            onClick: ($event: any) => (_ctx.sendSmartContract(estimation.uuid))
                          }, [
                            _hoisted_39,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('create_contract')), 1)
                          ], 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("tfoot", _hoisted_40, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_41, [
                    _createVNode(_component_EmptyData, {
                      title: _ctx.state.data.title,
                      heading: _ctx.state.data.headings
                    }, null, 8, ["title", "heading"])
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createVNode("div", _hoisted_42, [
      _createVNode("div", _hoisted_43, [
        _createVNode("div", _hoisted_44, [
          _createVNode("div", _hoisted_45, [
            _createVNode("div", _hoisted_46, [
              _createVNode("h5", _hoisted_47, _toDisplayString(_ctx.$t('delete_estimation')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteJobEstimationClose()))
              }, [
                _hoisted_48
              ])
            ]),
            _createVNode("div", _hoisted_49, [
              _hoisted_50,
              _createVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('are_you_sure')), 1)
            ]),
            _createVNode("div", _hoisted_52, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteJobEstimationClose()))
              }, _toDisplayString(_ctx.$t('no')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-dismiss": "modal",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteJobEstimation()))
              }, _toDisplayString(_ctx.$t('yes')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_53, [
      _createVNode("div", _hoisted_54, [
        _createVNode("div", _hoisted_55, [
          _createVNode("div", _hoisted_56, [
            _createVNode("div", _hoisted_57, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_58,
                    _hoisted_59
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline to-upper",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_60,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_61
            ]),
            _createVNode("div", _hoisted_62, [
              _createVNode("div", _hoisted_63, [
                _createVNode("div", _hoisted_64, [
                  _createVNode("div", _hoisted_65, [
                    _createVNode("div", _hoisted_66, [
                      (_ctx.state.data.details.logo || _ctx.state.data.companyInfo.logo)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: _ctx.state.data.details.logo ? _ctx.state.data.details.logo : _ctx.state.data.companyInfo.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_67, [
                      _createVNode("p", _hoisted_68, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_69, [
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_70, _toDisplayString(_ctx.$t('email')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.company?.company_email), 1)
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_71, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.company?.company_phone_number), 1)
                    ])
                  ])
                ]),
                _hoisted_72,
                _createVNode("div", _hoisted_73, [
                  _createVNode("div", _hoisted_74, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_75, _toDisplayString(_ctx.$t('estimation_title')), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                  ]),
                  _createVNode("div", _hoisted_76, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_77, _toDisplayString(_ctx.$t('estimation_no')), 1)
                    ]),
                    _createVNode("p", null, "#" + _toDisplayString(_ctx.state.data.details.no), 1)
                  ]),
                  _createVNode("div", _hoisted_78, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_79, _toDisplayString(_ctx.$t('date')), 1)
                    ]),
                    (_ctx.state.data.details.modifiedCreatedDate)
                      ? (_openBlock(), _createBlock("p", _hoisted_80, _toDisplayString(_ctx.state.data.details.modifiedCreatedDate), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_81, _toDisplayString(_ctx.state.data.details.created_date), 1))
                  ])
                ]),
                _createVNode("div", _hoisted_82, [
                  (_ctx.state.data.details && _ctx.state.data.details.customers && _ctx.state.data.details.customers.length)
                    ? (_openBlock(), _createBlock("p", _hoisted_83, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_84, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.customers, (customer, customerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-4",
                        key: customerIndex
                      }, [
                        _createVNode("div", _hoisted_85, [
                          (customer.first_name || customer.last_name)
                            ? (_openBlock(), _createBlock("p", _hoisted_86, [
                                _createVNode("strong", _hoisted_87, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.email)
                            ? (_openBlock(), _createBlock("p", _hoisted_88, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.phone || customer.contact_number)
                            ? (_openBlock(), _createBlock("p", _hoisted_89, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.phone || customer.contact_number), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_90, [
                  _createVNode("table", _hoisted_91, [
                    _createVNode("thead", _hoisted_92, [
                      _createVNode("tr", _hoisted_93, [
                        _createVNode("th", _hoisted_94, _toDisplayString(_ctx.$t('item')), 1),
                        _createVNode("th", _hoisted_95, _toDisplayString(_ctx.$t('description')), 1),
                        _createVNode("th", _hoisted_96, _toDisplayString(_ctx.$t('unit')), 1),
                        _createVNode("th", _hoisted_97, _toDisplayString(_ctx.$t('qty')), 1),
                        _createVNode("th", _hoisted_98, _toDisplayString(_ctx.$t('cost')), 1),
                        _createVNode("th", _hoisted_99, _toDisplayString(_ctx.$t('sub_total')), 1),
                        _createVNode("th", _hoisted_100, _toDisplayString(_ctx.$t('markup')), 1),
                        _createVNode("th", _hoisted_101, _toDisplayString(_ctx.$t('allowance')), 1),
                        _createVNode("th", _hoisted_102, _toDisplayString(_ctx.$t('total')), 1)
                      ])
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                      return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_103, [
                            _createVNode("p", _hoisted_104, [
                              _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_105, [
                                _createVNode("p", null, _toDisplayString(item.name), 1)
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("div", _hoisted_106, [
                                _createVNode("p", null, _toDisplayString(item.description), 1)
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.quantity), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.cost), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                            ]),
                            _createVNode("td", null, [
                              (item.markup_type == 1)
                                ? (_openBlock(), _createBlock("p", _hoisted_107, _toDisplayString(item.markup) + " %", 1))
                                : (_openBlock(), _createBlock("p", _hoisted_108, _toDisplayString(item.markup), 1))
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(item.allowance), 1)
                            ]),
                            _createVNode("td", _hoisted_109, [
                              _createVNode("p", null, _toDisplayString(item.total), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_110,
                _createVNode("div", _hoisted_111, [
                  _createVNode("div", _hoisted_112, [
                    _createVNode("div", _hoisted_113, [
                      _createVNode("table", _hoisted_114, [
                        _createVNode("tbody", null, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_115, _toDisplayString(_ctx.$t('total_amount')), 1),
                            _createVNode("th", _hoisted_116, _toDisplayString(_ctx.state.data.details.total), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_117,
                (_ctx.state.data.details.declined_customers && _ctx.state.data.details.declined_customers.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_118, [
                      _createVNode("p", _hoisted_119, [
                        _createVNode("strong", _hoisted_120, _toDisplayString(_ctx.$t('declined_reason')) + ": ", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.declined_customers[0].reason), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", null, [
                  _createVNode("div", null, [
                    ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement && _ctx.state.data.details.legal_statement))
                      ? (_openBlock(), _createBlock("p", _hoisted_121, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement &&
                                        _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement &&
                                            _ctx.state.data.details.legal_statement)
                                    )
                    ? (_openBlock(), _createBlock("div", _hoisted_122, [
                        _createVNode("div", _hoisted_123, [
                          _createVNode("ul", _hoisted_124, [
                            _createVNode("li", _hoisted_125, [
                              _createVNode("button", _hoisted_126, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                            ]),
                            _createVNode("li", _hoisted_127, [
                              _createVNode("button", _hoisted_128, _toDisplayString(_ctx.$t('legal_statement')), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_129, [
                            _createVNode("div", _hoisted_130, [
                              _createVNode("div", {
                                innerHTML: _ctx.state.data.details?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                              }, null, 8, ["innerHTML"])
                            ]),
                            _createVNode("div", _hoisted_131, [
                              _createVNode("div", {
                                innerHTML: _ctx.state.data.details?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                              }, null, 8, ["innerHTML"])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.state.status != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_132, [
                      _createVNode("p", _hoisted_133, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.status != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_134, [
                      _createVNode("p", _hoisted_135, [
                        _hoisted_136,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.channel), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.status != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_137, [
                      _createVNode("div", _hoisted_138, [
                        _createVNode("p", _hoisted_139, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('signatures')) + ":", 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_140, [
                        (_ctx.state.data.details.signature)
                          ? (_openBlock(), _createBlock("div", _hoisted_141, [
                              _createVNode("div", _hoisted_142, [
                                _createVNode("img", {
                                  src: _ctx.state.data.details.signature,
                                  alt: ""
                                }, null, 8, ["src"])
                              ]),
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('sender')) + ":", 1)
                              ]),
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                                _createTextVNode(_toDisplayString(_ctx.state.data.details.signature_date), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.singed_customers, (customer, customerIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "col-md-4",
                            key: customerIndex
                          }, [
                            _createVNode("div", _hoisted_143, [
                              _createVNode("img", {
                                src: customer.signature,
                                alt: ""
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("p", null, [
                              _createVNode("strong", _hoisted_144, _toDisplayString(_ctx.$t('customer')) + ": ", 1),
                              _createTextVNode(_toDisplayString(customer.name
                                                ?
                                                customer.name : customer.email), 1)
                            ]),
                            _createVNode("p", null, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(customer.signaute_date), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_145, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_146,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('print')) + "t", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_147,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", _hoisted_148, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_149, [
      _createVNode("div", _hoisted_150, [
        _createVNode("div", _hoisted_151, [
          _createVNode("div", _hoisted_152, [
            _createVNode("div", _hoisted_153, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_154,
                    _hoisted_155
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_156,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_157
            ]),
            _createVNode("div", _hoisted_158, [
              _createVNode("div", _hoisted_159, [
                _createVNode("div", _hoisted_160, [
                  _createVNode("div", _hoisted_161, [
                    _createVNode("div", _hoisted_162, [
                      (_ctx.state.data.details.logo || _ctx.state.data.companyInfo.logo)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: _ctx.state.data.details.logo ? _ctx.state.data.details.logo : _ctx.state.data.companyInfo.logo,
                            alt: ""
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_163, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_164, _toDisplayString(_ctx.$t('address')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_165, [
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_166, _toDisplayString(_ctx.$t('email')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.company?.company_email), 1)
                    ]),
                    _createVNode("p", null, [
                      _createVNode("span", _hoisted_167, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.company?.company_phone_number), 1)
                    ])
                  ])
                ]),
                _hoisted_168,
                _createVNode("div", _hoisted_169, [
                  _createVNode("div", _hoisted_170, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_171, _toDisplayString(_ctx.$t('estimation_title')), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                  ]),
                  _createVNode("div", _hoisted_172, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_173, _toDisplayString(_ctx.$t('estimation_no')), 1)
                    ]),
                    _createVNode("p", null, "#" + _toDisplayString(_ctx.state.data.details.no), 1)
                  ]),
                  _createVNode("div", _hoisted_174, [
                    _createVNode("p", null, [
                      _createVNode("strong", _hoisted_175, _toDisplayString(_ctx.$t('date')), 1)
                    ]),
                    (_ctx.state.data.details.modifiedCreatedDate)
                      ? (_openBlock(), _createBlock("p", _hoisted_176, _toDisplayString(_ctx.state.data.details.modifiedCreatedDate), 1))
                      : (_openBlock(), _createBlock("p", _hoisted_177, _toDisplayString(_ctx.state.data.details.created_date), 1))
                  ])
                ]),
                _createVNode("div", _hoisted_178, [
                  (_ctx.state.data.details && _ctx.state.data.details.customers && _ctx.state.data.details.customers.length)
                    ? (_openBlock(), _createBlock("p", _hoisted_179, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_180, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.customers, (customer, customerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-4",
                        key: customerIndex
                      }, [
                        _createVNode("div", _hoisted_181, [
                          (customer.first_name || customer.last_name)
                            ? (_openBlock(), _createBlock("p", _hoisted_182, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.email)
                            ? (_openBlock(), _createBlock("p", _hoisted_183, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (customer.phone || customer.contact_number)
                            ? (_openBlock(), _createBlock("p", _hoisted_184, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(customer.phone || customer.contact_number), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_185, [
                  (_ctx.state.status == 0)
                    ? (_openBlock(), _createBlock("table", _hoisted_186, [
                        _createVNode("thead", _hoisted_187, [
                          _createVNode("tr", _hoisted_188, [
                            _createVNode("th", _hoisted_189, _toDisplayString(_ctx.$t('item')), 1),
                            _createVNode("th", _hoisted_190, _toDisplayString(_ctx.$t('description')), 1),
                            _createVNode("th", _hoisted_191, _toDisplayString(_ctx.$t('qty')), 1),
                            _createVNode("th", _hoisted_192, _toDisplayString(_ctx.$t('unit')), 1),
                            _createVNode("th", _hoisted_193, _toDisplayString(_ctx.$t('cost')), 1),
                            _createVNode("th", _hoisted_194, _toDisplayString(_ctx.$t('markup')), 1),
                            _createVNode("th", _hoisted_195, _toDisplayString(_ctx.$t('allowance')), 1),
                            _createVNode("th", _hoisted_196, _toDisplayString(_ctx.$t('total')), 1)
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                          return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                            _createVNode("tr", null, [
                              _createVNode("td", _hoisted_197, [
                                _createVNode("p", _hoisted_198, [
                                  _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                                ])
                              ])
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                                _createVNode("td", null, [
                                  _createVNode("div", _hoisted_199, [
                                    _createVNode("p", null, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("div", _hoisted_200, [
                                    _createVNode("p", null, _toDisplayString(item.description), 1)
                                  ])
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.cost), 1)
                                ]),
                                _createVNode("td", null, [
                                  (item.markup_type == 1)
                                    ? (_openBlock(), _createBlock("p", _hoisted_201, _toDisplayString(item.markup) + " %", 1))
                                    : (_openBlock(), _createBlock("p", _hoisted_202, _toDisplayString(item.markup), 1))
                                ]),
                                _createVNode("td", null, [
                                  _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                ]),
                                _createVNode("td", _hoisted_203, [
                                  _createVNode("p", null, _toDisplayString(item.total), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock("table", _hoisted_204, [
                        _createVNode("thead", _hoisted_205, [
                          _createVNode("tr", _hoisted_206, [
                            _createVNode("th", _hoisted_207, _toDisplayString(_ctx.$t('item')), 1),
                            (_ctx.state.fields.description == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_208, _toDisplayString(_ctx.$t('description')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.unit == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_209, _toDisplayString(_ctx.$t('unit')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.quantity == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_210, _toDisplayString(_ctx.$t('qty')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.cost == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_211, _toDisplayString(_ctx.$t('cost')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.subTotal == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_212, _toDisplayString(_ctx.$t('sub_total')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.markup == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_213, _toDisplayString(_ctx.$t('markup')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.allowance == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_214, _toDisplayString(_ctx.$t('allowance')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.total == 1)
                              ? (_openBlock(), _createBlock("th", _hoisted_215, _toDisplayString(_ctx.$t('total')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                          return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                            _createVNode("tr", null, [
                              _createVNode("td", _hoisted_216, [
                                _createVNode("p", _hoisted_217, [
                                  _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                                ])
                              ])
                            ]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                              return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                                _createVNode("td", null, [
                                  _createVNode("div", _hoisted_218, [
                                    _createVNode("p", null, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                (_ctx.state.fields.description == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_219, [
                                      _createVNode("div", _hoisted_220, [
                                        _createVNode("p", null, _toDisplayString(item.description), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.unit == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_221, [
                                      _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.quantity == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_222, [
                                      _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.cost == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_223, [
                                      _createVNode("p", null, _toDisplayString(item.cost), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.subTotal == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_224, [
                                      _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.markup == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_225, [
                                      (item.markup_type == 1)
                                        ? (_openBlock(), _createBlock("p", _hoisted_226, _toDisplayString(item.markup) + " %", 1))
                                        : (_openBlock(), _createBlock("p", _hoisted_227, _toDisplayString(item.markup), 1))
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.allowance == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_228, [
                                      _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.state.fields.total == 1)
                                  ? (_openBlock(), _createBlock("td", _hoisted_229, [
                                      _createVNode("p", null, _toDisplayString(item.total), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ]))
                ]),
                _hoisted_230,
                _createVNode("div", _hoisted_231, [
                  _createVNode("div", _hoisted_232, [
                    _createVNode("div", _hoisted_233, [
                      _createVNode("table", _hoisted_234, [
                        _createVNode("tbody", null, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_235, _toDisplayString(_ctx.$t('total_amount')), 1),
                            _createVNode("th", _hoisted_236, _toDisplayString(_ctx.state.data.details.total), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_237,
                (_ctx.state.data.details.declined_customers && _ctx.state.data.details.declined_customers.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_238, [
                      _createVNode("p", _hoisted_239, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('declined_reason')) + ": ", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.declined_customers[0].reason), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement && _ctx.state.data.details.legal_statement))
                  ? (_openBlock(), _createBlock("p", _hoisted_240, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement && _ctx.state.data.details.legal_statement))
                  ? (_openBlock(), _createBlock("div", _hoisted_241, [
                      _createVNode("div", _hoisted_242, [
                        _createVNode("ul", {
                          class: "nav nav-tabs",
                          id: 'myTab-' + _ctx.modalIdentifier,
                          role: "tablist"
                        }, [
                          _createVNode("li", _hoisted_243, [
                            _createVNode("button", {
                              class: "nav-link active",
                              id: 'Contract-tab-' + _ctx.modalIdentifier,
                              "data-toggle": "tab",
                              "data-target": '#Contract-' + _ctx.modalIdentifier,
                              type: "button",
                              role: "tab",
                              "aria-controls": 'Contract-' + _ctx.modalIdentifier,
                              "aria-selected": "true"
                            }, _toDisplayString(_ctx.$t('acknowledgement')), 9, ["id", "data-target", "aria-controls"])
                          ]),
                          _createVNode("li", _hoisted_244, [
                            _createVNode("button", {
                              class: "nav-link",
                              id: 'Contract1-tab-' + _ctx.modalIdentifier,
                              "data-toggle": "tab",
                              "data-target": '#Contract1-' + _ctx.modalIdentifier,
                              type: "button",
                              role: "tab",
                              "aria-controls": 'Contract1-' + _ctx.modalIdentifier,
                              "aria-selected": "false"
                            }, _toDisplayString(_ctx.$t('legal_statement')), 9, ["id", "data-target", "aria-controls"])
                          ])
                        ], 8, ["id"]),
                        _createVNode("div", {
                          class: "tab-content",
                          id: 'myTabContent-' + _ctx.modalIdentifier
                        }, [
                          _createVNode("div", {
                            class: "tab-pane fade show active",
                            id: 'Contract-' + _ctx.modalIdentifier,
                            role: "tabpanel",
                            "aria-labelledby": 'Contract-tab-' + _ctx.modalIdentifier
                          }, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.details?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                            }, null, 8, ["innerHTML"])
                          ], 8, ["id", "aria-labelledby"]),
                          _createVNode("div", {
                            class: "tab-pane fade",
                            id: 'Contract1-' + _ctx.modalIdentifier,
                            role: "tabpanel",
                            "aria-labelledby": 'Contract1-tab-' + _ctx.modalIdentifier
                          }, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.details?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                            }, null, 8, ["innerHTML"])
                          ], 8, ["id", "aria-labelledby"])
                        ], 8, ["id"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_245, [
                  _createVNode("p", _hoisted_246, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_247, [
                  _createVNode("p", _hoisted_248, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('channel')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.channel), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_249, [
                  _createVNode("div", _hoisted_250, [
                    _createVNode("p", _hoisted_251, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('signatures')) + ":", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_252, [
                    (_ctx.state.data.details.signature)
                      ? (_openBlock(), _createBlock("div", _hoisted_253, [
                          _createVNode("div", _hoisted_254, [
                            _createVNode("img", {
                              src: _ctx.state.data.details.signature,
                              alt: ""
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('sender')) + ":", 1)
                          ]),
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                            _createTextVNode(_toDisplayString(_ctx.state.data.details.signature_date), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.singed_customers, (customer, customerIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-4",
                        key: customerIndex
                      }, [
                        _createVNode("div", _hoisted_255, [
                          _createVNode("img", {
                            src: customer.signature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", _hoisted_256, _toDisplayString(_ctx.$t('customer')) + ": ", 1),
                          _createTextVNode(_toDisplayString(customer.name
                                                ?
                                                customer.name : customer.email), 1)
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                          _createTextVNode(" " + _toDisplayString(customer.signaute_date), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_257, [
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn mr-2",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_258,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('print')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.details.pdf_link)
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                  }, [
                    _hoisted_259,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", _hoisted_260, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.ui.isActive.upgradeSubscription)
      ? (_openBlock(), _createBlock(_component_UpgradeSubscriptionModal, {
          key: 1,
          onCloseModal: _ctx.hideUpdateSubscriptionModal
        }, null, 8, ["onCloseModal"]))
      : _createCommentVNode("", true)
  ]))
}